import { PaymentProviderProps } from '../../../Payment';
import { SubscriptionHookParams } from '../../hooks/types';
import useNextCharge from '../../hooks/useNextCharge';

const usePaymentProviderData = ({
  currentSubscription,
}: SubscriptionHookParams): PaymentProviderProps => {
  const nextCharge = useNextCharge({
    currentSubscription,
  });

  return {
    mode: 'subscription',
    amount: nextCharge?.value.amount,
    currency: nextCharge?.value.currency.toLowerCase() ?? 'usd',
    captureMethod: 'automatic',
  };
};

export default usePaymentProviderData;
